import { buildFetchMutations } from '@/store/extensions/fetch';

export default {
  ...buildFetchMutations(['fetchLogs', 'fetchTimeLogLogs']),
};



// WEBPACK FOOTER //
// ./src/store/modules/log/mutations.js